import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import firebase from "./firebase";
import store from "./store";
import vuetify from "./plugins/vuetify";
import fns from "date-fns/format";

Vue.filter("dateFormat", value => fns(value.toDate(), "Do MMM 'YY"));
Vue.filter("dateFormatFull", value =>
  fns(value.toDate(), "Do MMM YYYY - HH:mm a")
);

Vue.config.productionTip = false;

let app = null;

firebase.auth().onAuthStateChanged(async user => {
  if (user) {
    store.commit("setUser");
    store.dispatch("fetchUserDetails");
  } else {
    store.commit("logout");
    store.commit("resetExercises");
    store.commit("clearOlympiads");
  }
  router.push("/");

  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  }
});
